<template>
  <v-dialog
    :value="show"
    width="600"
    content-class="pa-8 white"
    @click:outside="$emit('close')"
  >
    <div class="d-flex justify-space-between">
      <span class="text-h6 font-weight-bold">
        {{
          $t(
            'user-menu.select-language',
            'Select your language',
          )
        }}
      </span>
      <v-btn
        icon
        color="black"
        @click="$emit('close')"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-wrap mt-4">
      <v-btn
        v-for="language in languages"
        :key="language.lang_iso"
        color="orange"
        class="white--text mr-2 mt-2"
        rounded
        @click="switchLanguage(language)"
      >
        {{ language.translation || language.lang_name }}
      </v-btn>
    </div>
  </v-dialog>
</template>

<script>
  import { languages } from '~/static/languages.json';
  import { patch as updateMember } from '~/domains/Member/api';

  export default {
    name: 'LanguageSelector',
    props: {
      show: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        languages: languages.filter((language) => !!language.translation),
        currentLanguageTranslation: '',
      };
    },
    methods: {
      getInternational(code) {
        if (!code) return code;
        if (code.includes('-')) {
          return code.replace('-', '_');
        }
        return code;
      },
      async switchLanguage(language) {
        await this.changeLanguage(language);
        this.$emit('close');
      },
      async changeLanguage(language) {
        this.currentLanguageTranslation = language.translation;
        try {
          if (this.$LanguageService.currentLanguage !== language.lang_iso) {
            this.$nuxt.$loading.start();
            this.$LanguageService.changeLanguage(
              this.getInternational(language.lang_iso),
              (locale) => {
                const loc = this.getInternational(locale);
                return updateMember({
                  id: this.$auth.user.id,
                  attributes: {
                    locale: loc,
                  },
                });
              },
            );
          }
        } catch (err) {
          this.$nuxt.$loading.fail(err);
        }
      },
      direction(language) {
        return language.is_rtl ? 'rtl' : 'ltr';
      },
    },
  };
</script>
